'use client'

import { useMediaQuery } from 'usehooks-ts'

import { Breakpoints } from '@b-stock/fe-core/design-system'

export function useIsMobileTableLayout() {
  // Avoid hydration issues by assuming mobile on the first render for both SSR and CSR
  // Why mobile? Most of our buyers are mobile users (~58% based on early 2025 data),
  // so assuming mobile is more likely to be accurate (plus, it's less disruptive for
  // desktop users to see the filters pop into existence than for mobile users to see
  // the desktop filters pop out of existence)
  return useMediaQuery(Breakpoints.max.medium, {
    defaultValue: true,
    initializeWithValue: false,
  })
}
